module.exports = __webpack_public_path__ + "static/media/chat.346d5367.svg";